import { BaseDialog, BaseRadioGroup, BaseTextarea } from '@/shared/components'
import { useState } from 'react'

type Props = {
  isModalOpen: boolean
  onClose: (value: boolean) => void
  onSubmit: (option: string) => void
}

export const CancelOrderDialog = ({ isModalOpen, onClose, onSubmit }: Props) => {
  const [selectedOption, setSelectedOption] = useState('wrong_recipient')
  const [customReason, setCustomReason] = useState('')
  const [error, setError] = useState('')

  const options = [
    { name: 'Неверный получатель', value: 'wrong_recipient' },
    { name: 'Требуется выписка от клиента', value: 'requires_statement' },
    { name: 'Поддельный чек', value: 'fake_check' },
    { name: 'Другая причина', value: 'another_reason' },
  ]

  const handleCLose = () => {
    setError('')
    onClose(false)
    setSelectedOption('wrong_recipient')
  }

  const getReason = () => {
    if (selectedOption === 'another_reason') {
      return customReason.trim()
    }
    const found = options.find((opt) => opt.value === selectedOption)
    return found?.name || ''
  }

  const handleSubmit = () => {
    if (selectedOption === 'another_reason' && customReason.trim() === '') {
      setError('Пожалуйста, укажите причину')
      return
    }
    setError('')
    onSubmit(getReason())
  }

  return (
    <BaseDialog
      isVisible={isModalOpen}
      onClose={handleCLose}
      onStepBack={handleCLose}
      onAction={handleSubmit}
      actionButtonName="Отклонить спор"
      actionButtonVariant="red"
      closeButtonName="Вернуться назад"
      title="Хотите отклонить спор?"
    >
      <div className="flex flex-col gap-4">
        <p>Выберите причину:</p>
        <BaseRadioGroup value={selectedOption} onChange={setSelectedOption} options={options} />
        {selectedOption === 'another_reason' && (
          <div className="flex flex-col gap-0.5">
            <BaseTextarea
              placeholder="Укажите причину для отмены"
              size="sm"
              value={customReason}
              onChange={(e) => {
                setError('')
                setCustomReason(e.target.value)
              }}
              className={error && 'ring-error'}
            />
            {error && <span className="self-end text-error text-xs text-right">{error}</span>}
          </div>
        )}
      </div>
    </BaseDialog>
  )
}
